<template>
  <el-container
    style="
      display: flex;
      justify-content: center;
      margin: 5vh 5vw;
      max-height: 80vh;
      overflow-y: auto;
      overflow-x: hidden;
    "
  >
    <el-card
      style="width: 700px; height: 535px"
      body-style="display: flex; flex-direction: column; justify-content:center; align-items: center; padding: 0"
    >
      <img
        class="img"
        src="../assets/Final Logo Transparent 2.svg"
        style="
          object-fit: cover;
          width: 300px;
          height: 200px;
          object-position: left center;
          margin: 50px 0 -40px 0;
        "
      />
      <div
        style="
          margin-top: 20px;
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        "
      >
        <el-form
          @submit.native.prevent="resetPassword"
          style="width: 100%"
          :disabled="disableForm"
          ><el-form-item>
            <span slot="label">
              New Password
              <small>
                <el-tooltip placement="right" effect="light">
                  <span slot="content"
                    >The password must be between 8 and 32 characters in length,
                    contain only<br />lowercase, uppercase, and numeric
                    characters, and must contain at least one<br />lowercase/uppercase/number.</span
                  >
                  <i
                    class="el-icon-info"
                    style="position: relative; left: 2px; bottom: 4px"
                  />
                </el-tooltip>
              </small>
            </span>
            <el-input
              ref="password"
              type="password"
              v-model="$v.password.$model"
              :show-password="!disableForm"
              :class="{
                error: checkValid && $v.password.$invalid,
              }"
            />
          </el-form-item>
          <el-button
            class="button"
            style="width: 100%; margin-top: 40px"
            native-type="submit"
            >Reset Password</el-button
          >
        </el-form>
      </div>
    </el-card>
  </el-container>
</template>

<script>
import AuthenticationService from "../services/AuthenticationService";
import {
  required,
  alphaNum,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import Helper from "../utilities/Helper";
import { mapState } from "vuex";

/**
 * @vue-data {String} [password=null] - Current user's password
 * @vue-data {String} [error=null] - Error message to display
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 * @vue-data {Boolean} [showPassword=false] - Flag that indicates whether to show the password text
 */
export default {
  data() {
    return {
      token: null,
      password: null,
      checkValid: false,
      disableForm: false,
    };
  },
  computed: {
    ...mapState(["instanceId"]),
  },
  methods: {
    handleError: Helper.handleError,
    /**
     * Resets the user's password
     * @async
     * @function
     */
    async resetPassword() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        this.checkValid = true;
        await AuthenticationService.resetPassword({
          token: this.token,
          password: this.password,
        });
        this.disableForm = true;
        this.$message({
          type: "success",
          message:
            "Your password has been reset successfully. Log back in to DataMaestro to continue working.",
          duration: 5000,
          showClose: true,
        });
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    this.$refs.password.focus();
  },
  validations() {
    return {
      password: {
        required,
        alphaNum,
        minLength: minLength(8),
        maxLength: maxLength(32),
        meetsRequirements() {
          const regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/);
          return regex.test(this.password);
        },
      },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
</style>
